import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const location = useLocation();

  useLayoutEffect(() => {
    // Don't scroll to top if there's a hash in the URL (for anchor links)
    if (location.hash) {
      return; // Let the component handle hash scrolling
    }

    // Force scroll to top immediately only when there's no hash
    document.documentElement.scrollTo(0, 0);
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    
    // Check all scrollable elements and reset them
    const scrollableElements = document.querySelectorAll('*');
    scrollableElements.forEach(el => {
      if (el.scrollTop > 0) {
        el.scrollTop = 0;
      }
    });
  }, [location.pathname, location.hash, location.key]); // Added location.hash

  return null;
}